import apiService from '../../../services/api-client';
import { DeleteReceptionResponse } from '../interfaces/delete-reception';
import { DeleteReceptionOrderResponse } from '../interfaces/delete-reception-order';
import { GetReceptionContainerResponse } from '../interfaces/get-reception-container';
import { GetReceptionContainersResponse } from '../interfaces/get-reception-containers';
import { GetReceptionOrdersResponse } from '../interfaces/get-reception-orders';
import { GetReceptionsResponse } from '../interfaces/get-receptions';
import { PostReceptionPayloadRequest, PostReceptionResponse } from '../interfaces/post-reception';
import { PostReceptionOrderPayloadRequest, PostReceptionOrderResponse } from '../interfaces/post-reception-order';
import { PutReceptionPayloadRequest, PutReceptionResponse } from '../interfaces/put-reception';
import { PutReceptionContainerPayloadRequest, PutReceptionContainerResponse } from '../interfaces/put-reception-container';
import { PutReceptionOrderPayloadRequest, PutReceptionOrderResponse } from '../interfaces/put-reception-order';

export const receptionApiService = {
  async getReceptions(id: number, filters?: any) {
    let url = `company/${id}/receptions`;
    
    if (filters) {
      const params = new URLSearchParams();
      if (filters.search) params.append('search', filters.search);
      if (filters.business_id) params.append('business_id', filters.business_id.toString());
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
    }
    
    const { data } = await apiService().get<GetReceptionsResponse>(url);
    return data;
  },
  async postReception(id: number, body: PostReceptionPayloadRequest) {
    const { data } = await apiService().post<PostReceptionResponse>(`company/${id}/reception`, body);
    return data;
  },
  async putReception(cId: number, pId: number, body: PutReceptionPayloadRequest) {
    const { data } = await apiService().put<PutReceptionResponse>(
      `company/${cId}/reception/${pId}`,
      body
    );
    return data;
  },
  async putReceptionContainer(cId: number, pId: number, rId: number, body: PutReceptionContainerPayloadRequest) {
    const { data } = await apiService().put<PutReceptionContainerResponse>(
      `company/${cId}/reception/${pId}/container/${rId}`,
      body
    );
    return data;
  },
  async deleteReception(cId: number, pId: number) {
    const { data } = await apiService().delete<DeleteReceptionResponse>(
      `company/${cId}/reception/${pId}`
    );
    return data;
  },
  async getReceptionContainer(cId: number, rId: string) {
    const { data } = await apiService().get<GetReceptionContainerResponse>(`company/${cId}/receptionContainer/${rId}`);
    return data;
  },
  async getReceptionOrders(id: number, filters?: any) {
    let url = `company/${id}/receptionOrders`;
    
    if (filters) {
      const params = new URLSearchParams();
      if (filters.search) params.append('search', filters.search);
      if (filters.business_id) params.append('business_id', filters.business_id.toString());
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
    }
    
    const { data } = await apiService().get<GetReceptionOrdersResponse>(url);
    return data;
  },
  async postReceptionOrder(id: number, body: PostReceptionOrderPayloadRequest) {
    const { data } = await apiService().post<PostReceptionOrderResponse>(`company/${id}/receptionOrder`, body);
    return data;
  },
  async putReceptionOrder(cId: number, pId: number, body: PutReceptionOrderPayloadRequest) {
    const { data } = await apiService().put<PutReceptionOrderResponse>(
      `company/${cId}/receptionOrder/${pId}`,
      body
    );
    return data;
  },
  async deleteReceptionOrder(cId: number, pId: number) {
    const { data } = await apiService().delete<DeleteReceptionOrderResponse>(
      `company/${cId}/receptionOrder/${pId}`
    );
    return data;
  },
  async getReceptionContainers(cid: number, rid: number) {
    const { data } = await apiService().get<GetReceptionContainersResponse>(`company/${cid}/reception/${rid}/containers`);
    return data;
  },
  async getAllReceptionContainers(cid: number, page: number = 1, size: number = 100) {
    const { data } = await apiService().get<GetReceptionContainersResponse>(`company/${cid}/receptionContainers?page=${page}&size=${size}`);
    return data;
  },
};
